import axios from '../../common/utils/interceptor';
import { getLocalizedKeyByErrorMessage } from '../../authentication/utils/errorMessage';
import { apiUrls, defaultBranding } from '../../constants';
import { templateProvider, defaultTemplateProvider } from '../../store/providers/templateProvider';
import { getCookie, getCurrentLocale } from './cookies';
import { getExperienceInitCookie } from './experienceInitCookie';
import localizeContentMapper from './localizeContentMapper';
import { getStore } from '../../store';
import { companySettingsProvider } from '../../store/providers/companySettingsProvider';

export type error = { state: 'error' | 'info'; message: string };
export interface RequestData {
  link?: string | null;
  workflowSessionId?: string | null;
}

export const fetchTemplateSettings = async (requestData?: RequestData): Promise<error | undefined> => {
  const tcPlusFlow = getCookie('TcPlusFlag') === '1';
  const isBasicFlow = getCookie('BasicFlow') === '1';
  const expCookie = getExperienceInitCookie();
  const { setTemplate } = templateProvider();
  const { setDefaultTemplate } = defaultTemplateProvider();
  const { setCompanyBranding } = companySettingsProvider();

  try {
    let payLoad = {};
    if (tcPlusFlow) {
      payLoad = {
        workflowSessionId: requestData?.workflowSessionId,
        templateId: expCookie && expCookie.templateId,
        locale: getCurrentLocale(),
      };
    } else {
      payLoad = { tempLink: requestData?.link, locale: getCurrentLocale() };
    }
    const { data } = await axios.get(
      tcPlusFlow ? apiUrls.GET_TEMPLATE_SETTINGS_TCPLUS : apiUrls.GET_TEMPLATE_SETTINGS,
      {
        params: payLoad,
      },
    );
    if (data && data.Message) {
      return {
        state: 'error',
        message: getLocalizedKeyByErrorMessage(data.Message),
      };
    }
    // set templateSettings for reset password page branding
    // Fallback to default settings in case its null
    let parsedTemplateSettings = data.settings ? JSON.parse(data.settings) : defaultBranding;
    let companyBranding = getStore().state.companySettings.companyBranding;
    companyBranding = companyBranding && JSON.parse(companyBranding);
    if (isBasicFlow && companyBranding) parsedTemplateSettings = companyBranding;
    const templateSettings = localizeContentMapper(parsedTemplateSettings, data.localizedContentMap);
    const templateResponse = {
      ...data,
      settings: templateSettings,
    };
    isBasicFlow && data.settings && setCompanyBranding(data.settings);

    setDefaultTemplate(templateResponse);
    setTemplate(templateResponse);
  } catch (e) {
    if (e && e.data && e.data.Message) {
      return {
        state: 'error',
        message: getLocalizedKeyByErrorMessage(e.data.Message),
      };
    }
  }
};
